import { useEffect, useRef } from 'react';

export type OutsideAlerterProps = {
  funcDelegate: () => void;
};

type OutsideAlerter = {
  wrapperRef: React.RefObject<HTMLDivElement | null>;
};

const useOutsideAlerter = ({ funcDelegate: functionToExecute }: Readonly<OutsideAlerterProps>): OutsideAlerter => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        functionToExecute();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return (): void => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [functionToExecute]);

  return { wrapperRef };
};

export default useOutsideAlerter;
